import React, { useEffect, useState } from 'react';
import Button from '../global/Button';
import ConsentsApi from '../../api/consents';
import { clearStorageOnLogout, getAuthRedirectUrl } from '../../api/helpers';
import { useLocation } from 'react-router-dom';

const PrivacyAndTerms = (props) => {
  const location = useLocation();

  const [state, setState] = useState({
    consents: {},
  });

  useEffect(() => {
    async function fetchData() {
      const consentsData = await ConsentsApi.getConsents();
      setState({
        consents: consentsData ? consentsData.data : {},
      });
    }
    fetchData();
  }, []);

  const revokeConsent = async () => {
    props.addAlertToAlertsList({
      title: 'Confirm?',
      message:
        'Are you sure you want to revoke consent? By doing this you will be signed out of the app and no longer be able to access any of the content',
      messageStyle: { color: '#505A62' },
      confirmBtnText: 'NO',
      revokeBtnTxt: 'YES',
      revokeBtnAction: async () => {
        let { isPrivacy, isOrgTerms } = props.account;
        isPrivacy = location.pathname === '/privacy-policy';
        isOrgTerms = location.pathname === '/privacy-terms';
        await ConsentsApi.setConsentsAgreed({
          engage4: isPrivacy ? false : true,
          engage4Terms: true,
          organisation: isOrgTerms ? false : true,
        });
        clearStorageOnLogout();
        props.handleLogout();
        window.location.href = getAuthRedirectUrl();
      },
    });
  };

  const isPrivacy = props.account.isPrivacy || location.pathname === '/privacy-policy';
  const { consents } = state;
  const privacyText = consents.engage4 ? consents.engage4.text : '';
  const orgTermsText = consents.organisation ? consents.organisation.text : '';

  return (
    <>
      <div className="container-fluid on-boarding overflow-auto">
        <div>
          <div
            className="form-holder edit-profile-container col-md-6 offset-md-3 col-xl-4 offset-xl-4"
            style={{ marginTop: '36px' }}
          >
            <h3 className="title m-0 mb-2">
              {isPrivacy ? 'Privacy policy' : 'Terms and conditions'}
            </h3>
            <div
              style={{ fontSize: 14, flex: 1 }}
              dangerouslySetInnerHTML={{
                __html: isPrivacy ? privacyText : orgTermsText,
              }}
            ></div>
          </div>
          <div
            className="col-md-6 offset-md-3 col-xl-4 of
            fset-xl-4 button-holder"
          >
            <div className="col-3 offset-8 p-0">
              <Button.PrimaryOutline
                style={{ width: 180, color: '#AF365F', borderColor: '#AF365F' }}
                onClick={revokeConsent}
                type="submit"
              >
                REVOKE CONSENT
              </Button.PrimaryOutline>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyAndTerms;
